<div class="search__box">
	<span class="search__wrapper p-input-filled">
		<input
			#searchInput
			pInputText
			type="text"
			name="search"
			autocapitalize="off"
			autocomplete="off"
			autocorrect="off"
			[class]="inputStylesString"
			[class.with__search__button]="showSearchButton"
			[placeholder]="placeholder"
			[(ngModel)]="value"
			(focus)="onFocusEvent($event)"
			(blur)="onBlurEvent($event)"
			(ngModelChange)="onChangeEvent()"
		/>

		<p-button
			*ngIf="showSearchButton"
			type="button"
			icon="fa-solid fa-magnifying-glass"
			pTooltip="Pesquisar"
			tooltipPosition="bottom"
			[showDelay]="1000"
			[styleClass]="buttonStylesString"
			[loading]="isLoading"
			(onClick)="onClickEvent()"
		></p-button>
	</span>
</div>
